<template>
  <tr
    v-if="!event.isDeleted || isEditable"
    @click="selectEvent()"
    class="position-relative"
    :class="{ opacity: !isNotDeleted }"
  >
    <td>
      <span
        class="badge badge-fix-sm badge-pill mr-2"
        :class="event.color ? 'badge-' + event.color : 'badge-danger'"
        v-html="event.abbr"
      >
      </span>
      {{ event.title }}
      <template v-if="eventValue">
        {{ eventValue }}
      </template>
    </td>
    <td class="text-nowrap text-right">
      {{ eventTime }}
      <template v-if="eventDuration">
        ({{ eventDuration }})
      </template>
    </td>
    <td class="td-checkbox">
      <div v-if="isEditable">
        <label class="checkbox m-0">
          <input type="checkbox" v-model="isNotDeleted" @change="selectInput" />
        </label>
      </div>
    </td>
  </tr>
</template>

<script>
import timeString from '@/modules/time-string.js'
import timeDuration from '@/modules/time-duration'
import { DATE_FORMAT } from '@/main.config.js'

export default {
  name: 'TrainingEventRow',
  props: {
    event: {
      type: Object,
      required: true
    },
    isEditable: {
      type: Boolean,
      required: true
    },
    isAstroTimeMode: {
      type: Boolean,
      required: true
    },
    trainingDateStart: {
      type: Date,
      required: true
    }
  },
  data: () => ({
    selected: [],
    isNotDeleted: false
  }),
  computed: {
    eventValue() {
      if (!this.event.value) {
        return null
      }
      if (this.event.abbr == 'EB') {
        switch (this.event.value) {
          case 'B':
            return this.$t('colour.black')
          case 'R':
            return this.$t('colour.red')
          case 'W':
            return this.$t('colour.white')
          case 'Br':
            return this.$t('colour.brown')
          default:
            return ''
        }
      }
      if (!this.event.unit) {
        if (this.event.type === 'LostSamples') {
          const num = +this.event.value
          return `- ${num.toFixed(3).replace('.', ',')}`
        } else return `- ${this.event.value}`
      }
      return `= ${this.event.value + this.event.unit}`
    },
    eventTime() {
      if (this.event.isDuration) {
        const beginStr = this.getEventTimeString(this.event.begin)
        const endStr = this.getEventTimeString(this.event.end)

        return `${beginStr} - ${endStr}`
      }

      return this.getEventTimeString(this.event.begin)
    },
    eventDuration() {
      if (!this.event.isDuration) {
        return null
      }

      return timeDuration(this.event.begin, this.event.end)
    }
  },
  created() {
    this.isNotDeleted = !this.event.isDeleted
  },
  methods: {
    selectEvent() {
      this.$emit('input', this.event.begin)
    },
    selectInput() {
      this.$emit('selectEvent', this.event.key, !this.isNotDeleted)
    },
    /**
     * Возвращает строку, содержащую время регистрации кардиособытия
     * @param {number} eventSeconds Относительное время регистрации кардиособытия в секундах с начала сессии/тренировки
     */
    getEventTimeString(eventSeconds) {
      if (!eventSeconds || isNaN(eventSeconds))
        return '?'
      
      if (this.isAstroTimeMode) {
        const astroDate = new Date(this.trainingDateStart.getTime() + eventSeconds * 1000)
        return this.moment(astroDate).format(DATE_FORMAT.timeHMS)
      }

      return timeString(eventSeconds, true)
    }
  }
}
</script>
